import { ReactElement } from "react";
import { Link } from "react-router";

export type TrendingTopicItem = {
  label: string;
  href?: string;
};

type TrendingTopicsProps = {
  title?: string;
  topics: TrendingTopicItem[];
};

export default function TrendingTopics({
  title = "Trending Topics",
  topics,
}: TrendingTopicsProps): ReactElement | null {
  if (!topics.length) {
    return null;
  }

  return (
    <section
      className="flex flex-col gap-2.5 w-full border-t-2 border-brand-primary my-2.5 py-2.5"
      aria-label={title}
    >
      <h2 className="text-brand-primary text-base font-primary font-semibold leading-[150%] py-1">
        {title}
      </h2>
      <div className="flex flex-wrap gap-5">
        {topics.map(({ label, href }) => {
          const key = href ?? label.trim().toLowerCase().replace(/\s+/g, "-");
          const chipClassName =
            "inline-flex items-center bg-neutral-200 text-neutral-700 text-xxs leading-[120%] px-2.5 py-[5px]";

          if (href) {
            return (
              <Link
                key={key}
                to={href}
                className={chipClassName}
                aria-label={`Go to trending topic ${label}`}
              >
                {label}
              </Link>
            );
          }

          return (
            <span key={key} className={chipClassName}>
              {label}
            </span>
          );
        })}
      </div>
    </section>
  );
}
